import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NewsService } from '../services/news.service';
import { News } from '../interfaces/news.interface';
import { Subscription } from 'rxjs';
import { ScrollPositionService } from '../services/scroll-position.service';


@Component({
  selector: 'app-news',
  standalone: false,
  templateUrl: './news.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly PAGE_SIZE = 50;
  private newsSub: Subscription | null = null;

  news: News[] = [];
  total = 0;
  loading = false;
  loadingMore = false;

  get hasMore(): boolean {
    return this.news.length < this.total;
  }

  constructor(
    private newsService: NewsService,
    private scrollPositionService: ScrollPositionService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.newsSub = this.newsService.getList({
      order_by: 'sort',
      order: 'desc',
      skip: 0,
      limit: this.PAGE_SIZE,
    }).subscribe(res => {
      this.news = res.items || [];
      this.total = res.total ?? this.news.length;
      this.loading = false;
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scrollPositionService.restorePosition('/wiadomosci');
    }, 200);
  }

  ngOnDestroy(): void {
    this.newsSub?.unsubscribe();
  }

  loadNextPage(): void {
    if (this.loadingMore || !this.hasMore) return;
    this.loadingMore = true;
    this.newsService.getList({
      order_by: 'is_top desc, sort',
      order: 'desc',
      skip: this.news.length,
      limit: this.PAGE_SIZE,
    }).subscribe(res => {
      this.news = this.news.concat(res.items || []);
      this.total = res.total ?? this.total;
      this.loadingMore = false;
    });
  }
}
